import { UIResultCommandInterface } from './ui-result-command.interface';
import { UIResultCommand } from './ui-result-command';

export class UICommand extends UIResultCommand<void> implements UIResultCommandInterface<void> {

}
